import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-region",
  "use": "icon-region-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-region\">\n<path d=\"M9.6002 6.40557C9.6002 7.28923 8.88386 8.00557 8.0002 8.00557C7.11655 8.00557 6.4002 7.28923 6.4002 6.40557C6.4002 5.52191 7.11655 4.80557 8.0002 4.80557C8.88386 4.80557 9.6002 5.52191 9.6002 6.40557Z\" stroke=\"#020617\" stroke-width=\"1.1\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol